import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GraphDataAPIResponse,
  GraphOffersApiResponse,
  GroupedOffersDataModel,
  OfferRequest,
  OfferResponse,
  OperationalGroup,
  OperationalGroupApiResponse,
  RequestBodyInterface
} from '@dr-customer-offers-ui/lib-interfaces';
import { APIData } from 'common-utils/dist/models/api';
import { EMPTY, Observable } from 'rxjs';
import { expand, map, reduce } from 'rxjs/operators';
import { ApiEndpointsService } from '../api-endpoint/api-endpoints.service';

@Injectable({
  providedIn: 'root'
})
export class OfferService {
  constructor(
    private http: HttpClient,
    private apiService: ApiEndpointsService
  ) {}

  getGroupedOffers(registration_id: string, start_dttm: string, end_dttm: string): Observable<OperationalGroup[] | null> {
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers/grouped?start_dttm=` + start_dttm + `&end_dttm=` + end_dttm;
    return this.http.get<OperationalGroupApiResponse>(url, { withCredentials: true }).pipe(map((res) => res.data));
  }

  getGraphDataOffers(registration_id: string, start_dttm: string, end_dttm: string): Observable<GraphDataAPIResponse> {
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers/time-series?start_dttm=` + start_dttm + `&end_dttm=` + end_dttm;
    return this.http.get<GraphOffersApiResponse>(url, { withCredentials: true }).pipe(map((res: GraphOffersApiResponse) => res.data));
  }

  getClearedGraphDataOffers(registration_id: string, start_dttm: string, end_dttm: string): Observable<GraphDataAPIResponse> {
    const { baseUrl } = this.apiService;
    const url =
      `${baseUrl}/registrations/` +
      registration_id +
      `/offers/time-series?full_response=false&start_dttm=` +
      start_dttm +
      `&end_dttm=` +
      end_dttm +
      `&clear_offer=true`;
    return this.http.get<GraphOffersApiResponse>(url, { withCredentials: true }).pipe(map((res: GraphOffersApiResponse) => res.data));
  }

  putGraphDataOffers(registration_id: string, body: RequestBodyInterface[]): Observable<any> {
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers`;
    return this.http.put<any>(url, body, { withCredentials: true }).pipe(map((res: GraphOffersApiResponse) => res.data));
  }

  putGroupedOffers(registration_id: string, offers: GroupedOffersDataModel[]): Observable<OfferResponse[] | null> {
    console.log('putOffers');
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers/grouped`;
    return this.http.put<APIData<OfferResponse[] | null>>(url, offers, { withCredentials: true }).pipe(map((res) => this.extractOffersData(res)));
  }

  getOffers(registration_id: string, start_dttm: string, end_dttm: string): Observable<OfferResponse[] | null> {
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers?start_dttm=` + start_dttm + `&end_dttm=` + end_dttm;
    return this.http.get<APIData<OfferResponse[] | null>>(url, { withCredentials: true }).pipe(map((res) => this.extractOffersData(res)));
  }

  getExportOffers(registration_id: string, start_dttm: string, end_dttm: string): Observable<OfferResponse[]> {
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/${registration_id}/offers?start_dttm=${start_dttm}&end_dttm=${end_dttm}&full_response=false`;
    return this.http.get<APIData<OfferResponse[] | null>>(url, { withCredentials: true }).pipe(
      expand((res) =>
        res?.links?.nextPage
          ? this.http.get<APIData<OfferResponse[] | null>>(`${new URL(baseUrl).origin}/${res.links.nextPage}`, { withCredentials: true })
          : EMPTY
      ),
      map((res) => this.extractOffersData(res) ?? []),
      reduce((acc, cur) => acc.concat(cur), [] as OfferResponse[])
    );
  }

  putOffers(registration_id: string, offers: OfferRequest[]): Observable<OfferResponse[] | null> {
    console.log('putOffers');
    const { baseUrl } = this.apiService;
    const url = `${baseUrl}/registrations/` + registration_id + `/offers`;
    return this.http.put<APIData<OfferResponse[] | null>>(url, offers, { withCredentials: true }).pipe(map((res) => this.extractOffersData(res)));
  }

  private extractOffersData(res: APIData<OfferResponse[] | null>): OfferResponse[] | null {
    const payload = res.data;
    return payload as OfferResponse[] | null;
  }
}
